<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="pagevii"></a>Illustrations</h2>
<p class="paracenter"><em>Between pages 128 and 129</em></p>
<p class="paranoindent1" style="margin-top:1em;"><span href="#/14_chapter5#ill1" title="Link target outside of Sample">25th Dragoons begin bunker-busting in the Arakan</span></p>
<p class="paranoindent1"><span href="#/14_chapter5#ill2" title="Link target outside of Sample">Close quarter action at Hill 1070</span></p>
<p class="paranoindent1"><span href="#/14_chapter5#ill3" title="Link target outside of Sample">B Squadron 3rd Carabiniers and 1st Dogras begin to climb Nunshigum</span></p>
<p class="paranoindent1"><span href="#/14_chapter5#ill4" title="Link target outside of Sample">British infantry, supported by Lees, clear a village during the Imphal battle</span></p>
<p class="paranoindent1"><span href="#/14_chapter5#ill5" title="Link target outside of Sample">An historic meeting</span></p>
<p class="paranoindent1"><span href="#/14_chapter5#ill6" title="Link target outside of Sample">Waiting to cross. A troop of 7th Light Cavalry preparing to cross the Irrawaddy</span></p>
<p class="paranoindent1"><span href="#/14_chapter5#ill7" title="Link target outside of Sample">A Carabinier Lee comes ashore in 2nd Division’s bridgehead</span></p>
<p class="paranoindent1"><span href="#/14_chapter5#ill8" title="Link target outside of Sample">On the road to Mandalay</span></p>
<p class="paranoindent1"><span href="#/14_chapter5#ill9" title="Link target outside of Sample">Tanks of 150 Regiment RAC, with Mandalay hill</span></p>
<p class="paranoindent1"><span href="#/14_chapter5#ill10" title="Link target outside of Sample">A Sherman of the Royal Deccan Horse in action at Yewe</span></p>
<p class="paranoindent1"><span href="#/14_chapter5#ill11" title="Link target outside of Sample">The Carabiniers support an infantry attack</span></p>
<p class="paranoindent1"><span href="#/14_chapter5#ill12" title="Link target outside of Sample">The dash to Rangoon</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_illustrations.vue?a8daeb14